/*
 * Copyright (c) 2023-2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      21 February 2024
 */

import { Link } from 'react-router-dom';

export const classNames = (...classes: any[]) => {
  return classes.filter(Boolean).join(' ');
};

const Footer = () => {
  return (
    <footer className='bg-transparent'>
      <div className='mx-auto max-w-7xl px-6 pt-20 sm:pt-24 lg:px-8'>
        <nav
          className='-mb-6 columns-2 flex flex-row justify-center sm:space-x-12'
          aria-label='Footer'
        >
          <div className='pb-6 px-5 sm:px-0'>
            <Link
              to='/'
              className='text-dark-300 text-sm leading-6 hover:text-dark-100 font-poppins'
            >
              Projects
            </Link>
          </div>
          <div className='pb-6 px-5 sm:px-0'>
            <Link
              to='/about-us'
              className='text-dark-300 text-sm leading-6 hover:text-dark-100 font-poppins'
            >
              About Us
            </Link>
          </div>
          <div className='pb-6 px-5 sm:px-0'>
            <Link
              to='/contact-us'
              className='text-dark-300 text-sm leading-6 hover:text-dark-100 font-poppins'
            >
              Contact Us
            </Link>
          </div>
        </nav>
        <div className='mt-10 flex flex-row justify-center space-x-10'>
          <a href='#' className='text-dark-300 hover:text-dark-100'>
            <span className='sr-only'>Instagram</span>
            <i className='icon-[bi--instagram] h-6 w-6'></i>
          </a>
          <a href='#' className='text-dark-300 hover:text-dark-100'>
            <span className='sr-only'>Instagram</span>
            <i className='icon-[bi--vimeo] h-6 w-6'></i>
          </a>
          <a href='#' className='text-dark-300 hover:text-dark-100'>
            <span className='sr-only'>Instagram</span>
            <i className='icon-[bi--youtube] h-6 w-6'></i>
          </a>
          <a href='#' className='text-dark-300 hover:text-dark-100'>
            <span className='sr-only'>Instagram</span>
            <i className='icon-[bi--linkedin] h-6 w-6'></i>
          </a>
        </div>
        <p className='mt-10 text-center text-xs leading-5 text-gray-500'>
          &copy; 2022-{new Date().getFullYear()} ARTCUT, Inc. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
